import apiFetch from '../apiFetch'

export default function (idSeguimiento, token) {
  return apiFetch({endPoint: `Seguimiento/eliminarSeguimiento?idSeguimiento=` + idSeguimiento, method: 'GET', body: null, token: token})
}
